<template>
  <div class="main">
    <div class="logo">
      <!-- <img src="../assets/logo.png" alt="" /> -->
    </div>
    <div class="form">
      <img src="../assets/loginBg.png" alt="" />
      <!-- 表单 -->
      <div class="formData">
        <h3>欢迎注册</h3>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              style="width: 100%; border-radius: 30px; margin-top: 10px"
              type="primary"
              @click="submitForm('ruleForm')"
              >立即注册</el-button
            >
          </el-form-item>
          <div class="tip">
            <span class="tologin">已有账号?</span>
            <router-link :to="{ path: '/login' }"
              ><span>马上登录</span></router-link
            >
          </div>
          <el-form-item class="xieyi" label="" prop="type">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox label="我已阅读并同意" name="type"></el-checkbox>
            </el-checkbox-group>
            <span class="ls" @click="agreement(1)">《服务协议》</span>
            <span class="ls" @click="agreement(2)">《隐私政策》</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="company">
      <p>河北睿银金融服务外包有限公司</p>
      <p>版权所有 @ 河北睿银金融服务外包有限公司.冀ICP备18005534号-1</p>
    </div>
    <!-- 用户注册协议 -->
    <el-dialog
      title="用户注册协议"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div style="height: 500px" class="scrollbar">
        <el-scrollbar style="height: 100%">
          <p>用户注册协议</p>
          <p>
            本协议是您与本公司商城所有者之间就网站服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击"同意并继续"按钮后，本协议即构成对双方有约束力的法律文件。
          </p>
          <p>第1条 本站服务条款的确认和接纳</p>
          <p>
            1.1本站的各项电子服务的所有权和运作权归本公司商城所有。用户同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
          </p>
          <p>
            1.2用户点击同意本协议的，即视为用户确认自己具有享受本站服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。
          </p>
          <p>
            1.3如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用本站。
          </p>
          <p>
            1.4本公司商城保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
          </p>
          <p>第2条 本站服务</p>
          <p>
            2.1本公司商城通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及本站规定的情况下，方有权使用本站的相关服务。
          </p>
          <p>2.2用户必须自行准备如下设备和承担如下开支：</p>
          <p>
            （1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；
          </p>
          <p>
            （2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。
          </p>
          <p>第3条 用户信息</p>
          <p>
            3.1用户应自行诚信向本站提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且本公司商城保留终止用户使用本公司商城各项服务的权利。
          </p>
          <p>
            3.2用户在本站进行浏览、下单购物等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。
          </p>
          <p>
            3.3用户注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。
          </p>
          <p>
            3.4用户同意，本公司商城拥有通过邮件、短信电话等形式，向在本站注册、购物用户、收货人发送订单信息、促销活动等告知信息的权利。
          </p>
          <p>
            3.5用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。
          </p>
          <p>
            3.6用户同意，本公司商城有权使用用户的注册信息、用户名、密码等信息，登录进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。
          </p>
          <p>第4条 用户依法言行义务</p>
          <p>本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</p>
          <p>
            （1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
          </p>
          <p>（2）从中国大陆向境外传输资料信息时必须符合中国有关法规；</p>
          <p>
            （3）不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
          </p>
          <p>（4）不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；</p>
          <p>
            （5）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；
          </p>
          <p>
            （6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；
          </p>
          <p>（7）不得教唆他人从事本条所禁止的行为；</p>
          <p>（8）不得利用在本站注册的账户进行牟利性经营活动；</p>
          <p>
            （9）不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；
          </p>
          <p>用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。</p>
          <p>
            本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。
          </p>
          <p>
            若用户未遵守以上规定的，本站有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。
          </p>
          <p>第5条 店铺义务</p>
          <p>
            5.1店铺经营者可通过本站申请店铺，发布全新或二手商品及/或服务信息并与其他用户达成交易，但必须保证商品信息真实。如有发现商品假冒或者其他违反国家法律规定的商品，本站有权对商品进行禁售。
          </p>
          <p>
            5.2若店铺经营者发生改变，店铺经营者需及时联系本站进行信息的变更，若未及时联系本站而导致消费者与原店铺经营者产生交易纠纷或者违法国家规定的事情，本站不负任何连带责任。
          </p>
          <p>
            5.3店铺经营者有权通过使用店铺设置短暂关停店铺，但店铺经营者应当对自己店铺关停前已达成的交易继续承担发货、退换货及质保维修、维权投诉处理等交易保障责任。
          </p>
          <p>
            5.4店铺经营者如有不实交易信息或者违反国家相关法律的行为，本站有权对店铺进行关停，并对关停期间所产生的损失不负任何责任。
          </p>
          <p>依据上述约定关停店铺均不会影响您已经累积的信用。</p>
          <p>第6条 商品信息</p>
          <p>
            本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；本公司商城欢迎纠错，并会视情况给予纠错者一定的奖励。
          </p>
          <p>为表述便利，商品和服务简称为"商品"或"货物"。</p>
          <p>第7条 订单</p>
          <p>
            7.1在您下订单时，请您仔细确认所购商品的名称、价格、数量、规格、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。
          </p>
          <p>
            7.2除法律另有强制性规定外，双方约定如下：本站上销售方展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售方发出的合同要约；销售方收到您的订单信息后，只有在销售方将您在订单中订购的商品从仓库实际直接向您发出时（
            以商品出库为标志），方视为您与销售方之间就实际直接向您发出的商品建立了合同关系；如果您在一份订单里订购了多种商品并且销售方只给您发出了部分商品时，您与销售方之间仅就实际直接向您发出的商品建立了合同关系；只有在销售方实际直接向您发出了订单中订购的其他商品时，您和销售方之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登录您在本站注册的账户，查询您的订单状态。
          </p>
          <p>
            7.3由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品，发生缺货，您有权取消订单。
          </p>
          <p>第8条 配送</p>
          <p>
            8.1销售方将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。
          </p>
          <p>
            8.2因如下情况造成订单延迟或无法配送等，销售方不承担延迟配送的责任：
          </p>
          <p>（1）用户提供的信息错误、地址不详细等原因导致的；</p>
          <p>（2）货物送达后无人签收，导致无法配送或延迟配送的；</p>
          <p>（3）情势变更因素导致的；</p>
          <p>（4）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。</p>
          <p>第9条 交易争议处理</p>
          <p>
            您在本公司商城平台交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：
          </p>
          <p>（1）与争议相对方自主协商；</p>
          <p>（2）使用本公司商城网站提供的争议调处服务；</p>
          <p>（3）请求消费者协会或者其他依法成立的调解组织调解；</p>
          <p>（4）向有关行政部门投诉；</p>
          <p>（5）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；</p>
          <p>（6）向人民法院提起诉讼。</p>
          <p>第10条 责任限制及不承诺担保</p>
          <p>
            10.1除非另有明确的书面说明,本站及其所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在"按现状"和"按现有"的基础上提供的。
          </p>
          <p>
            10.2除非另有明确的书面说明,本公司商城不对本站的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
          </p>
          <p>
            本公司商城不担保本站所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。
          </p>
          <p>
            如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，本公司商城会合理地尽力协助处理善后事宜。
          </p>
          <p>第11条 协议更新及用户关注义务</p>
          <p>
            根据国家法律法规变化及网站运营需要，本公司商城有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议；用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受本公司商城网站依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。本公司商城建议您在使用本站之前阅读本协议及本站的公告。
            如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
          </p>
          <p>附则</p>
          <p>
            1本公司商城尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本站欢迎用户和社会各界提出意见和建议，本公司商城将虚心接受并适时修改本协议及本站上的各类规则。
          </p>
          <p>
            2本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。
          </p>
          <p>
            3您点击本协议下方的"同意并注册"按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
          </p>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog
      title="隐私政策"
      :visible.sync="dialogVisible1"
      width="50%"
    >
      <div style="height: 500px" class="scrollbar">
        <el-scrollbar style="height: 100%">
          <p>隐私政策</p>
          <p>河北睿银金融服务外包有限公司  （以下简称“河北睿银金融服务外包有限公司”）</p>
          <p>河北睿银金融服务外包有限公司原则</p>
          <p>河北睿银金融服务外包有限公司为了保护用户发布的内容、维护良好的站内环境，河北睿银金融服务外包有限公司团队和河北睿银金融服务外包有限公司的管理员将依据河北睿银金融服务外包有限公司协议和本规范中的条款对注册河北睿银金融服务外包有限公司的用户和发布在河北睿银金融服务外包有限公司的内容进行管理。采取的措施包括但不限于更改或删除用户发布的内容、暂停或终止用户使用河北睿银金融服务外包有限公司的权利。</p>
          <p>受理范围</p>
          <br>
          <p>违反法律法规：发布违反国家相关法律法规及「七条底线」、「九不准」管理规定的信息，主要表现为：</p>
          <br>
          <p>反对宪法所确定的基本原则</p>
          <p>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一</p>
          <p>损害国家荣誉和利益</p>
          <p>煽动民族仇恨、民族歧视，破坏民族团结</p>
          <p>破坏国家宗教政策，宣扬邪教和封建迷信</p>
          <p>散布谣言，扰乱社会秩序，破坏社会稳定</p>
          <p>宣扬淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪</p>
          <p>煽动非法集会、结社、游行、示威、聚众扰乱社会秩序</p>
          <p>诽谤他人，泄露他人隐私，侵害他人合法权益</p>
          <p>含有法律、行政法规禁止的其他内容的信息</p>
          <p>不友善行为：不尊重河北睿银金融服务外包有限公司用户及其所贡献内容的行为，主要表现为：</p><p></p>
          <br>
          <p>轻蔑：贬低、轻视他人及其劳动成果</p>
          <p>诽谤：捏造、散布虚假事实，损害他人名誉</p>
          <p>嘲讽：以比喻、夸张、侮辱性的手法对他人或其行为进行揭露或描述，以此来激怒他人</p>
          <p>挑衅：以不友好的方式激怒他人，意图使对方对自己的言论作出回应，蓄意制造事端</p>
          <p>羞辱：贬低他人的能力、行为、生理或身份特征，让对方难堪</p>
          <p>谩骂：以不文明的语言对他人进行负面评价</p>
          <p>歧视：针对他人的民族、种族、宗教、性取向、性别、年龄、地域、生理特征等身份或者归类的攻击</p>
          <p>威胁：许诺以不良的后果来迫使他人服从自己的意志</p>
          <p>发布垃圾广告信息：用户以推广曝光为目的，发布影响用户体验、扰乱河北睿银金融服务外包有限公司网站秩序的内容，或进行相关行为。</p>
          <p>多次发布包含售卖产品、提供服务、宣传推广内容的垃圾广告。包括但不限于以下几种形式：</p>
          <br>
          <p>单个帐号多次发布包含垃圾广告的内容</p>
          <p>多个广告帐号互相配合发布包含垃圾广告的内容</p>
          <p>多次发布包含欺骗性外链的内容，如未注明的淘宝客链接、跳转网站等，诱骗用户点击链接</p>
          <p>发布大量包含 SEO 推广链接的内容获取搜索引擎中的不正当曝光</p>
          <p>购买或出售帐号之间虚假地互动，发布干扰社区秩序的推广内容及相关交易。包括但不限于以下几种形式：</p>
          <br>
          <p>购买机器注册帐号的关注伪造在社区内的影响力</p>
          <p>购买机器注册帐号点击赞同谋求回答的不正当曝光</p>
          <p>使用严重影响用户体验的违规手段进行恶意营销。包括但不限于以下几种形式：</p>
          <br>
          <p>不规范转载他人内容同时加入推广营销内容</p>
          <p>发布包含欺骗性的恶意营销内容，如通过伪造经历、冒充他人等方式进行恶意营销</p>
          <p>使用特殊符号、图片等方式规避垃圾广告内容审核的广告内容。</p>
          <p>恶意行为：滥用产品功能，进行影响用户体验，危及平台安全及损害他人权益的行为。主要表现为：</p>
          <br>
          <p>恶意编辑，指清空或删除有效内容，添加无关信息，破坏内容结构等降低公共编辑内容质量的编辑</p>
          <p>冒充他人，通过头像、用户名等个人信息暗示自己与他人或机构相等同或有关联</p>
          <p>重复发布干扰正常用户体验的内容。包括但不限于以下几种形式：</p>
          <p>重复的内容多次发布</p>
          <p>频繁发布难以辨识涵义影响阅读体验的字符、数字等无意义乱码</p>
          <p>骚扰他人，以评论、@ 他人、私信等方式对他人反复发送重复或者相似的诉求</p>
          <p>诱导投票或关注，如通过点赞抽奖、集赞更新等形式诱导投票或者诱导关注</p>
          <p>制作及传播外挂或者用于操作帐号功能的恶意程序或相关教程</p>
          <p>发布含有潜在危险的内容，如钓鱼网站、木马、病毒网站等</p>
          <p>举报方式</p>
          <p>站内举报河北睿银金融服务外包有限公司举报功能如何使用？</p>
          <p>侵权投诉：用户在河北睿银金融服务外包有限公司发表的内容仅表明其个人的立场和观点，并不代表河北睿银金融服务外包有限公司的立场或观点。如果个人或企业发现河北睿银金融服务外包有限公司上存在侵犯自身合法权益的内容，可以先尝试与作者取得联系，通过沟通协商解决问题。如您无法联系到作者，或无法通过与作者沟通解决问题，您可通过点击内容下方的举报按钮来向河北睿银金融服务外包有限公司平台进行投诉。为了保证问题能够及时有效地处理，请务必提交真实有效、完整清晰的材料，否则投诉将无法受理。</p>
          <p>对于侵犯您个人合法权益的投诉，您需要向河北睿银金融服务外包有限公司提供的投诉材料包括：</p>
          <br>
          <p>举报人的身份证明，身份证明可以是身份证或护照；</p>
          <p>如果举报人非权利人，请举报人提供代表权利人进行举报的书面授权证明。</p>
          <p>对于侵犯您企业合法权益的投诉，您需要向河北睿银金融服务外包有限公司提供的举证材料包括：</p>
          <br>
          <p>权利人对涉嫌侵权内容拥有商标权、著作权和/或其他依法可以行使权利的权属证明，权属证明通常是营业执照或组织机构代码证；</p>
          <p>举报人的身份证明，身份证明可以是身份证或护照；</p>
          <p>如果举报人非权利人，请举报人提供代表权利人进行举报的书面授权证明。</p>
          <p>为确保投诉材料的真实性，在侵权举报中，您还需要签署以下法律声明：</p>
          <br>
          <p>我本人为所举报内容的合法权利人；</p>
          <p>我举报的发布在河北睿银金融服务外包有限公司社区中的内容侵犯了本人相应的合法权益；</p>
          <p>如果本侵权举报内容不完全属实，本人将承担由此产生的一切法律责任，并承担和赔偿河北睿银金融服务外包有限公司因根据投诉人的通知书对相关帐号的处理而造成的任何损失，包括但不限于河北睿银金融服务外包有限公司因向被投诉方赔偿而产生的损失及河北睿银金融服务外包有限公司名誉、商誉损害等。</p>
          <p>详细规范可查看河北睿银金融服务外包有限公司协议 侵权举报。</p>
          <p>需要注意的是我们在以下方面共享您的信息</p>
          <p>您的个人信息是我们为您提供服务的重要部分，我们会遵循法律规定对您的信息承担保密义务。除以下情形外，我们不会将您的信息披露给第三方：</p>
          <br>
          <p>1、出于为您提供服务的目的，将您的信息提供给河北睿银金融服务外包有限公司的合作方，例如：为认证您的企业身份及店铺信息，我们将您的信息提供给专业的认证公司。</p>
          <p>2、出于实现“我们通过如下方式使用您的信息”部分所述目的，或为履行我们的义务和/或行使我们的权利，向河北睿银金融服务外包有限公司的关联方、合作伙伴或代表河北睿银金融服务外包有限公司履行某项职能的第三方（例如代表我们发出推送通知的通讯服务商、处理银行卡的支付机构等）分享您的个人信息。</p>
          <p>3、我们会为了协助解决争议而向投诉人/被投诉人披露您的信息，以便双方处理可能产生的权利纠纷。</p>
          <p>4、您出现违反中国有关法律、法规规定或者违反您与河北睿银金融服务外包有限公司的相关协议或违反相关河北睿银金融服务外包有限公司平台规则时需要向第三方披露的情形。</p>
          <p>5、根据法律法规的规定或行政或司法机构的要求，对外披露您的信息。</p>
          <p>6、经过您的授权或同意的其他需共享您信息的情况。</p>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatorPhone = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      dialogVisible1: false,
      ruleForm: {
        name: "",
        pass: "",
        type: [],
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }],
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请同意用户注册协议",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    agreement(type) {
      if (type == 1) {
        this.dialogVisible = true;
      } else {
        this.dialogVisible1 = true;
      }

    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            message: "注册成功！",
            type: "success",
          });
          setTimeout(() => {
            this.$router.push({
              path: "/login",
            });
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
<style lang="less" scoped>
.main {
  padding-bottom: 50px;
  background: #f2f6fc;
  .logo {
    height: 100px;
    // padding: 100px 0 100 50px;
    // img {
    //   width: 160px;
    //   height: 60px;
    // }
  }
  .form {
    display: flex;
    width: 900px;
    margin: 0 auto;
    img {
      width: 450px;
      height: 500px;
    }
    .formData {
      flex: 1;
      background: #ffffff;
      h3 {
        padding-top: 20px;
        text-align: center;
        font-size: 30px;
        color: #515a6e;
      }

      .el-form {
        padding-right: 50px;
      }
      .tip {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        text-align: center;
        a {
          text-decoration: none;
        }
        .router-link-active {
          text-decoration: none;
        }
        span {
          font-size: 14px;
          color: #2d8cf0;
        }
        .tologin {
          color: #515a6e;
          padding-left: 100px;
          padding-right: 10px;
        }
      }
      /deep/.el-form-item__content {
        display: flex;
        .ls {
          cursor: pointer;
          color: #2d8cf0;
        }
      }
    }
  }
  .company {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
    color: #515a6e;
  }
  /deep/.scrollbar {
    // white-space: nowrap; //强制一行显示（看需要）
    .el-scrollbar {
      display: flex;
      justify-content: space-around;
      padding: 0 10px;
      p {
        line-height: 24px;
        padding-bottom: 10px;
      }
    }
    /deep/.el-scrollbar__wrap {
      // 必要的
      overflow: scroll;
      width: 110%; //隐藏侧边默认滚动条 （达不到效果可以自己试着微调） 如解决不了可尝试用 `margin-right -60px`
      height: 100%; //隐藏底部滚动条  （100%如果达不到效果可以试着用110%）

    }
  }
}
</style>